import { Stack, Group, Text, ActionIcon, ScrollArea } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import styles from "../MobileAppointmentForm.module.css";

function StaffSection({
  formData,
  onChange,
  onClose,
  employees,
  errors,
  validateSection,
}) {
  const handleStaffSelect = (staffId) => {
    onChange({ employeeId: staffId });
  };

  const handleClose = () => {
    validateSection("staff");
    onClose();
  };

  return (
    <Stack gap={0} p="md" h="100dvh">
      {/* Header */}
      <Group w="100%" justify="space-between">
        <Text size="lg" fw={500}>
          Select Staff
        </Text>
        <ActionIcon
          onClick={handleClose}
          variant="subtle"
          color="var(--mantine-color-gray-1)"
        >
          <IconX size={20} color="var(--mantine-color-gray-7)" />
        </ActionIcon>
      </Group>

      {/* Error Message */}
      {errors.employeeId && (
        <Text size="sm" c="red">
          {errors.employeeId}
        </Text>
      )}

      {/* Staff List */}
      <ScrollArea h="calc(100dvh - 120px)" mt="md">
        <Stack gap={0}>
          {employees.map((employee) => (
            <div
              key={employee.id}
              className={`${styles.selectionItem} ${formData.employeeId === employee.id ? styles.selected : ""}`}
              onClick={() => handleStaffSelect(employee.id)}
            >
              <Stack gap={0}>
                <Text size="md" fw={500}>
                  {employee.first_name} {employee.last_name}
                </Text>
                <Text size="sm" c="dimmed">
                  {employee.title}
                </Text>
              </Stack>
            </div>
          ))}
        </Stack>
      </ScrollArea>
    </Stack>
  );
}

export default StaffSection;
